'use strict';

require('../../style/index.less');

require('./index.less');

require('../../select/style');

require('../../checkbox/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/tree-select/style/index.js
 ** module id = 245
 ** module chunks = 0
 **/